/**
 * Created by manoraj.k on 17/08/17.
 */
import styled from 'styled-components';
import { colors } from '../../colorCodes';

export const Tab = styled.div`
    display: inline-block;
    cursor: pointer;
    padding: 13px;
    font-size: 13px;
    font-family: Arial;
    height: 100%;
    box-sizing: border-box;
    &.active {
        border-bottom: solid 2px ${colors.brandBlue};
        font-weight: bold;
    }
`;

export const TabContainer = styled.div`
    height: 44px;
    padding-left: 18px;
    box-shadow: 0 2px 4px 0 hsla(0, 0%, 85%, 0.5);
    font-family: Arial;
    .tab-bar-name {
        font-size: 13px;
        margin-right: 10px;
    }
`;
